import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import type {RootState} from "../Store";
import {selectPour} from "../redux/Pour";
import Loader from "../components/Loader";
import {selectCart} from "../redux/Cart";
import {useForm} from "react-hook-form";
import {addCart, setCart, deleteItemCart} from "../redux/Order";
import Button from "../components/Button";

type Inputs = {
    qty: number;
};

const Pour = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {id, pid} = useParams();
    const data = useSelector((state: RootState) => state);
    const {register, handleSubmit} = useForm<Inputs>();
    const [qty, setQty] = useState(8);
    const [imgSrc, setImgSrc] = useState('/img/soft-drink_15542962.png');

    const onSubmit = () => {

        let item = {
            id: data.pour.detail.id,
            name: data.pour.detail.beverageDetail.name,
            price: data.pour.detail.price * qty,
            unitName: data.pour.detail.beverageDetail.unitName,
            taxPrice:
                data.pour.detail.price * qty * (1 + data.cart.detail.tax / 100) -
                data.pour.detail.price * qty,
            qty: qty,
        };

        let index = data.order.items.findIndex((i: any) => i.id === data.pour.detail.id);

        if (index !== -1) {
            dispatch(deleteItemCart(index));
        }

        dispatch(addCart(item));

        navigate("/stripe");

    };

    const QtyMinus = () => {
        let newQty = qty - 1;
        if (newQty < 1) newQty = 1;
        setQty(newQty);
    };

    const QtyPlus = () => {
        let newQty = qty + 1;

        if(newQty > 25){
            newQty = 25;
        }

        setQty(newQty);
    };

    useEffect(() => {

        if (data.cart.list.length > 0 && Array.isArray(data.cart.detail) && data.cart.detail.length === 0) {

            let detail = data.cart.list.find((cartList: { code: any }) => cartList.code == id);
            dispatch(selectCart(detail));

        }

        if (data.pour.list.length > 0 && data.pour.detail.length < 1) {

            let detail = data.pour.list.find((pourList: { position: any }) => pourList.position == pid);

            if(detail.beverageDetail?.logo && detail.beverageDetail.logo != 'null' && detail.beverageDetail?.logo != "https://pourtertech.com/storage"){
                setImgSrc(detail.beverageDetail.logo);
            }
            dispatch(selectPour(detail));

        }

    });

    const getLocalStorageItems = (): { key: string; value: string }[] => {
        const items: { key: string; value: string }[] = [];

        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key !== null) {
                const value = localStorage.getItem(key);
                items.push({key, value: value || ""}); // Fallback to an empty string if value is null
            }
        }

        return items;
    };

    const items = getLocalStorageItems();

    console.log(data.pour.detail.beverageDetail);

    return (
        <>

            {data.pour.detail.id && (
                <div key={pid} className="bg-gray-100">
                    <div className="w-full flex justify-center p-6">
                        <img
                            width="150"
                            src={imgSrc}
                            className=""
                        />
                    </div>
                    <div className="bg-white w-full flex flex-col justify-center p-6 rounded-xl rounded-b-none">
                        <div className="justify-between">
                            <h3 className="text-xl font-bold text-center m-2"> #{data.pour.detail.position} {data.pour.detail.beverageDetail.name}</h3>
                            <h3 className="text-xl font-normal text-center m-2">
                                $ {data.pour.detail.price.toFixed(2)} / {" "}
                                {data.pour.detail.beverageDetail.unitName}
                            </h3>
                        </div>
                        <div className="w-full bg-white py-4">
                            <form onSubmit={handleSubmit(onSubmit)} className="">
                                <div className="flex justify-between pb-10 pt-10 m-auto">
                                  <span
                                      className="w-20 h-20 text-4xl font-bold bg-primary-btn rounded-full flex items-center justify-center text-white transition transform duration-150 active:scale-90 active:shadow-inner focus:outline-none focus:ring-2 focus:ring-purple-300"
                                      onClick={QtyMinus}
                                  >
                                    -
                                  </span>

                                    <input
                                        {...register("qty")}
                                        type={"hidden"}
                                        value={qty}
                                        className="text-center max-w-10 text-xl font-bold"
                                    />
                                    <div>
                                        <label className="block text-center max-w-50 text-2xl font-normal p-1">
                                            {" "}
                                            <strong>{qty}</strong>{" "}
                                            {data.pour.detail.beverageDetail.unitName}{" "}
                                        </label>
                                        <label className="block text-center max-w-50 text-2xl font-bold p-1">
                                            {" "}
                                            $ {(parseFloat(data.pour.detail.price) * qty).toFixed(
                                            2
                                        )}{" "}
                                        </label>
                                    </div>
                                    <span
                                        className="w-20 h-20 text-4xl font-bold bg-primary-btn rounded-full flex items-center justify-center text-white transition transform duration-150 active:scale-90 active:shadow-inner focus:outline-none focus:ring-2 focus:ring-purple-300"
                                        onClick={QtyPlus}
                                    >
                    +
                  </span>
                                </div>
                                <div className="mx-auto">
                                    <Button
                                        style="checkout"
                                        className="mt-0"
                                        type="submit"
                                        onClick={function (): void {
                                            console.log("");
                                        }}
                                    >
                                        {" "}
                                        Check out
                                    </Button>
                                </div>
                            </form>
                        </div>

                        {data.pour.detail.beverageDetail.description && data.pour.detail.beverageDetail.description !='null' &&
                            <div className="flex flex-col text-gray-500 justify-between mb-8 m-auto">
                                <p>
                                    {data.pour.detail.beverageDetail.description}
                                </p>
                            </div>
                        }
                    </div>
                </div>
            )}

            {!data.pour.detail.id && <Loader/>}

        </>
    );
};

export default Pour;
